/**
 * Dependencies.
 */
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import 'vue-advanced-cropper/dist/style.css';
import 'reflect-metadata';
import './plugins/services.plugin';
import './plugins/kit.plugin';
import './plugins/icons.plugin';
import './plugins/ui.plugin';
import './plugins/composition.plugin';

import { PkRootPage } from '@prz-dp/ui';
import Vue from 'vue';

import Base from '@/modules/base';
import { i18n } from '@/plugins/i18n.plugin';
import vuetify from '@/plugins/vuetify.plugin';
import store from '@/store';

import { boot } from './boot';
import { installProzisStorePlugin } from './plugins/prozis-store.plugin';
import router from './plugins/router.plugin';

/**
 * Install Prozis Store plugin.
 */
installProzisStorePlugin();

/**
 * Vue use.
 */
Vue.use(Base, { store });

Vue.config.productionTip = false;

/**
 * Vue app.
 */
window.app = new Vue({
  components: { PkRootPage },
  async created() {
    await boot(this);
  },
  i18n,
  render: (h) => h(PkRootPage),
  router,
  store,
  vuetify
}).$mount('#app');
